// src/components/layout/Header.tsx
import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../common/Logo';
import HeaderUserChip from './HeaderUserChip';
import { AuthContext } from '../../context/AuthContext';

const Header: React.FC = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    navigate('/');
    setTimeout(() => window.location.reload(), 10);
  };

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-all duration-200 ${
        scrolled
          ? 'bg-white/95 backdrop-blur shadow-md border-gray-200'
          : 'bg-white/80 backdrop-blur-sm border-transparent'
      }`}
    >
      <div className="max-w-container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex-1 hidden md:block" />

        <div className="flex justify-center items-center">
          <Link to="/" onClick={handleLogoClick} className="focus:outline-none">
            <Logo size="large" showText />
          </Link>
        </div>

        <div className="flex-1 flex justify-end items-center space-x-4">
          <Link
            to="/about"
            className="text-sm text-textSecondary hover:text-primary font-medium"
          >
            About
          </Link>

          {user ? (
            <HeaderUserChip />
          ) : (
            <Link
              to="/auth"
              className="text-sm bg-primary text-white px-4 py-2 rounded-md hover:bg-green-600 transition"
            >
              Sign In
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;